import React from 'react';
import useWithStore from "@/Hooks/useWithStore";
import {isDesktop, isMobile} from "@/Helpers/Function";
import {Breadcrumbs} from "@mui/material";
import reachGoalYM from "@/Helpers/ReachGoalYM";
import reachGoalGA from "@/Helpers/ReachGoalGA";
import CatalogCard from "@/Components/Site/CatalogCard";
import Link from "@/Layouts/Link";
import isEmpty from "is-empty";
import Svg from "@/Components/Svg";
import {withViewItemBatcher} from "@/Context/ViewItemBatcherContext";
import '@/Pages/Collections/scss/wish.scss';

class Wish extends React.Component {
    constructor(props) {
        super(props);
        this.videoRef = React.createRef();
    }

    componentDidMount = () => {
        reachGoalYM('wish');
        reachGoalGA('wish');
    }

    state = {
        videoSvg: false,
        videoPlayPauseFlag: true,
        videoVolumeSvg: true,
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.videoRef.current !== null) {
            const video = this.videoRef.current;
            video.onended = (e) => {
                video.muted = true;
                this.setState({
                    videoSvg: true,
                    videoVolumeSvg: true
                })
            };
        }
    }

    videoTimer = () => setTimeout(() => {
        this.setState({videoPlayPauseFlag: false})
    }, 3000);

    /**
     * Управление звуком
     */
    mediaChangeVolume = () => {
        if (this.videoRef.current !== null) {
            const video = this.videoRef.current;
            if (video.muted) {
                video.muted = false;
                this.setState({videoVolumeSvg: false})
            } else {
                video.muted = true;
                this.setState({videoVolumeSvg: true})
            }
        }
    }

    /**
     * Убираем кнопку паузы на мобилке
     */
    mediaChangePlayPause = () => {
        if (!isDesktop()) {
            clearInterval(this.videoTimerId);
            if (!this.state.videoPlayPauseFlag) {
                this.setState({videoPlayPauseFlag: true})
            }
            this.videoTimerId = this.videoTimer();
        }
    }

    /**
     * Воспроизведение / пауза видео
     */
    mediaChange = () => {
        if (this.videoRef.current !== null) {
            const video = this.videoRef.current;
            if (video.paused) {
                video.play();
                this.setState({videoSvg: false})
            } else {
                video.pause();
                this.setState({videoSvg: true})
            }
            video.onended = (e) => {
                this.setState({videoSvg: true})
            };
        }
    }

    /**
     * Логотип коллекции
     * @param dataWish
     * @returns {JSX.Element|null}
     */
    logo = (dataWish) => {
        if (isEmpty(dataWish) || dataWish.logoPath === '' || dataWish.logoPathWebp === '') {
            return null;
        }

        return <div className={`logoWish`}>
            <picture>
                <source type={`image/webp`}
                        srcSet={dataWish.logoPathWebp}
                />
                <img src={dataWish.logoPath}
                     alt={`Logo`}
                     title={`Logo`}
                     loading={`lazy`}
                />
            </picture>
        </div>
    }

    /**
     * Видео
     * @param dataWish
     * @param state
     * @returns {JSX.Element}
     */
    video = (dataWish, state) => {
        if (isEmpty(dataWish)) {
            return null;
        }

        const source = dataWish.videoSource.map((el) => {
            return <source key={el.id}
                           src={isMobile() ? el.pathMobile : el.pathDesktop}
                           type={el.type} />
        });

        return <div className={`wish-wrapper__videoMain`}>
            <div className={`wish-wrapper__video`}>
                <video ref={this.videoRef}
                       autoPlay
                       muted={`muted`}
                       preload={`none`}
                       width={`100%`}
                       poster={isMobile() ? dataWish.videoPosterMobile : dataWish.videoPosterDesktop}
                >
                    {source}
                </video>
                <div className={`video-control`} onClick={() => this.mediaChangePlayPause()}>
                    {state.videoSvg ?
                        <div className={`gg-play-button`} onClick={() => this.mediaChange()}></div>
                        :
                        <>
                            {state.videoPlayPauseFlag && (
                                <div className={`gg-pause-button`} onClick={() => this.mediaChange()}></div>
                            )}
                        </>
                    }
                    <div className={`volume`} onClick={() => this.mediaChangeVolume()}>
                        {state.videoVolumeSvg ?
                            <Svg id={`volumeOffOutlinedIcon`} className={`svg__muted-off`} />
                            :
                            <Svg id={`volumeDownOutlinedIcon`} className={`svg__muted-on`} />
                        }
                    </div>
                </div>
            </div>
            <div className={`wish-wrapper__content`}>
                <div className={`img`}>
                    <img src={`/storage/img/collections/wish/banner-top-new.png`}
                         alt={`Изображение`}
                         title={`Изображение`}
                         loading="lazy" />
                </div>
                <div className={`text`}>
                    Ваши самые сокровенные пожелания
                </div>
                <Link href={`/catalog/i-wish`} className={`btn btn__wish`}>
                    Смотреть украшения
                </Link>
            </div>
        </div>
    }

    /**
     * H1
     * @param dataWish
     * @returns {JSX.Element}
     */
    h1 = (dataWish) => {
        if (isEmpty(dataWish) || isEmpty(dataWish.h1)) {
            return null;
        }

        return <h1 className={`h1 h1__wish`}>
            {dataWish.h1}
        </h1>
    }

    /**
     * Текст
     * @param dataWish
     * @returns {JSX.Element}
     */
    text = (dataWish) => {
        if (isEmpty(dataWish) || isEmpty(dataWish.description)) {
            return null;
        }
        return <>
            {dataWish.description.map((el, i) => {
                return <p key={i}
                          className={`wish-wrapper__description`}>
                    {el}
                </p>
            })}
        </>
    }

    /**
     * Sets
     * @param dataWish
     * @param registerView
     * @returns {null|*}
     */
    sets = (dataWish, registerView) => {
        if (isEmpty(dataWish)) {
            return null;
        }

        let cardList = [], offset = 0;
        return dataWish.sets.map((el) => {
            cardList = el.dataCardSet.map((product, i) => {
                return <CatalogCard
                    key={product.id}
                    el={product}
                    {...this.props}
                    index={offset + i + 1}
                    registerView={registerView}
                />
            })
            offset += el.dataCardSet.length;

            return <div key={el.id} className={`wish-wrapper__set`}>
                {el.title.map((el, i) => {
                    return <p key={i}
                              className={`setTitle`}
                    >
                        {el}
                    </p>
                })}
                {el.description.map((el, i) => {
                    return <p key={i}
                              className={`setDescription`}
                    >
                        {el}
                    </p>
                })}
                <picture>
                    {el.pictureSource.map((el) => {
                        return <source key={el.id}
                                       type={el.type}
                                       srcSet={el.path}
                                       media={el.media}
                        />
                    })}
                    <img src={el.picturePath}
                         alt={el.pictureAlt}
                         title={el.pictureAlt}
                         loading={`lazy`}
                         width={isMobile() ? "768" : "1500"}
                         height={isMobile() ? "768" : "624"}
                    />
                </picture>
                <div className={`cardWrapper`}>
                    {cardList}
                </div>
                {el.buttons.map((el) => {
                    return <Link key={el.id} href={el.link} className={el.className}>{el.text}</Link>
                })}
            </div>
        });
    }

    /**
     * Buttons
     * @param dataWish
     * @returns {null|*}
     */
    buttons = (dataWish) => {
        if (isEmpty(dataWish) || isEmpty(dataWish.buttons)) {
            return null;
        }

        const button = dataWish.buttons.map((el) => {
            return <Link key={el.id} href={el.link} className={el.className}>{el.text}</Link>
        });

        return button;
    }

    render() {
        const {collectionDetailedData = {}, stores = {}, uploadUrl = '', registerView} = this.props;
        const {collectionsStore = {}} = stores;

        return <section className={`section section__wish`}>
            <div className={`breadcrumbs`}>
                <div className="container">
                    <Breadcrumbs maxItems={3} itemsAfterCollapse={3}>
                        <Link className={`breadcrumbs__link`} href={`/`}>
                            Главная
                        </Link>
                        <Link className={`breadcrumbs__link`} href={`/collections`}>
                            Коллекции
                        </Link>
                        <p className={`breadcrumbs__text`}>
                            I WISH
                        </p>
                    </Breadcrumbs>
                </div>
            </div>
            <div className={`collections-lp collections-lp__wish`}>
                <div className={`container`}>
                    {this.logo(collectionDetailedData)}
                    <div className={`wish-wrapper`}>
                        {this.h1(collectionDetailedData)}
                        {this.video(collectionDetailedData, this.state)}
                        {this.text(collectionDetailedData)}
                        {this.sets(collectionDetailedData, registerView)}
                        <div className={`buttons buttons__wish`}>
                            {this.buttons(collectionDetailedData)}
                        </div>
                        <div className={`wish-wrapper__interview`}>
                            <div className={`interview__content`}>
                                <div className={`img`}>
                                    <img src={`/storage/img/collections/wish/i-wish-200x200.png`} alt={`Изображение`}
                                         loading="lazy" />
                                </div>
                                <p className={`text`}>
                                    Интервью с автором коллекции «I wish» Ольгой Потехиной
                                </p>
                            </div>
                            <div className={`interview__video`}>
                                {isMobile() ?
                                    <video id={`video_wish`}
                                           preload={`none`}
                                           width={`100%`}
                                           poster={`/storage/img/collections/wish/interview_cover.jpg`}
                                    >
                                        <source
                                            src={`${uploadUrl}/media/video/collections/i_wish/I-Wish_интервью_768х_2.5mbps.mp4`}
                                            type={`video/mp4`} />
                                        <source
                                            src={`${uploadUrl}/media/video/collections/i_wish/I-Wish_интервью_768х_2.5mbps.webm`}
                                            type={`video/webm`} />
                                    </video>
                                    :
                                    <video id={`video_wish`}
                                           preload={`none`}
                                           width={`100%`}
                                           poster={`/storage/img/collections/wish/interview_cover.jpg`}
                                    >
                                        <source
                                            src={`${uploadUrl}/media/video/collections/i_wish/I-Wish_интервью_1330x_2.5mbps.mp4`}
                                            type={`video/mp4`} />
                                        <source
                                            src={`${uploadUrl}/media/video/collections/i_wish/I-Wish_интервью_1330x_2.5mbps.webm`}
                                            type={`video/webm`} />
                                    </video>
                                }
                                <div className={`video-control`}
                                     onClick={() => collectionsStore.mediaNorthernLightsMainPlayPause()}>
                                    {collectionsStore.videoWishSvg ?
                                        <>
                                            <div className={`gg-play-button`}
                                                 onClick={() => collectionsStore.mediaWish()}></div>
                                        </>
                                        :
                                        <>
                                            {collectionsStore.videoNorthernLightsMainPlayPauseFlag ?
                                                <div className={`gg-pause-button`}
                                                     onClick={() => collectionsStore.mediaWish()}></div>
                                                : null
                                            }
                                        </>
                                    }
                                </div>
                            </div>
                        </div>
                        <div className={`wish-wrapper__wishes`}>
                            <p>
                                Желать самого сокровенного&nbsp; с&nbsp;украшениями &laquo;I&nbsp;wish&raquo;
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    }
}

export default withViewItemBatcher(useWithStore(Wish));
